export default "__VITE_ASSET__129b6058__"